import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lot-bids-list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "bidder-name" }
const _hoisted_4 = {
  key: 0,
  class: "small-date"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "bid" }


import { useAuctionStore } from "@/stores/AuctionStore";
import { format_currency } from "@/utils/currencies";
import { trans } from "@/utils/trans";
import { IBidsListItem } from "@/models";
import FormattedDate from "@/components/_partials/FormattedDate.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LotBidsList',
  props: {
    bidsListProp: {},
    isAdmin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const auctionStore = useAuctionStore();

const getUserName = (item: IBidsListItem) => {
  return item.belongs_to_user
    ? trans('live.catalog.lot_details_popup.your_bid')
    : item.user_name;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bidsListProp, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['row-bid', { 'current-user': item.belongs_to_user }]),
        key: item.user_name
      }, [
        _createElementVNode("img", {
          src: item.avatar_path,
          class: "user-avatar",
          alt: "avatar"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(getUserName(item)) + " ", 1),
          (_ctx.isAdmin || item.belongs_to_user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createTextVNode(" ( ")),
                _createVNode(FormattedDate, {
                  "utc-date": item.utc_date,
                  "moment-js-format": "MMM DD, LT"
                }, null, 8, ["utc-date"]),
                _cache[1] || (_cache[1] = _createTextVNode(" ) "))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(FormattedDate, {
                  "utc-date": item.utc_date,
                  "moment-js-format": "MMM DD, LT"
                }, null, 8, ["utc-date"])
              ]))
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(item.bids_count), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(format_currency)(item.highest_bid)), 1)
      ], 2))
    }), 128))
  ]))
}
}

})